NtechApp.NotificationManager = function($view) {
    var me = this;

    this._$view = null;

    this._ajax = null;
    this._click = null;

    this._isSavingContactRequestResponse = false;
    this._originalContactResponseText = "";

    this._isSavingJoinTeamResponse = false;

    this._construct = function() {
        me._$view = $view;

        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen(me._$view, "[data-acceptContactRequestNotification]", function(e) {
            var $item = $(e.target).closest("[data-acceptContactRequestNotification]");
            me._saveContactRequestResponse(
                $item, $item.attr("data-acceptContactRequestNotification"), "accept"
            );
        });

        me._click.listen(me._$view, "[data-denyContactRequestNotification]", function(e) {
            var $item = $(e.target).closest("[data-denyContactRequestNotification]");
            me._saveContactRequestResponse(
                $item, $item.attr("data-denyContactRequestNotification"), "decline"
            );
        });

        me._click.listen(me._$view, "[data-acceptJoinTeamRequestNotification]", function(e) {
            var $item = $(e.target).closest("[data-acceptJoinTeamRequestNotification]");
            var teamMemberId = $item.attr("data-acceptJoinTeamRequestNotification");

            var acceptMemberForm = new NtechApp.AcceptNewTeamMemberForm();
            acceptMemberForm.loadForm(teamMemberId);

            $("body").trigger("click");

            $(acceptMemberForm).on(NtechApp.AcceptNewTeamMemberForm.EVENT_MEMBER_ADDED, function(e, memberName, positionName, memberId) {
                me._updateAcceptJoinRequestNotification($item, memberName, positionName, memberId);
            });
        });

        me._click.listen(me._$view, "[data-denyJoinTeamRequestNotification]", function(e) {
            var $item = $(e.target).closest("[data-denyJoinTeamRequestNotification]");

            NtechApp.confirmForm.load(function() {
                me._saveDeclineJoinTeamResponse(
                    $item, $item.attr("data-denyJoinTeamRequestNotification")
                );
            });
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.NotificationManager, {
    _getSaveContactRequestResponseRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'personal_save_contact_request_response';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_save_contact_request_response';
    },

    _saveContactRequestResponse: function($item, contactId, action) {
        var me = this;

        if(this._isSavingContactRequestResponse)
            return;

        this._isSavingContactRequestResponse = true;
        this._originalContactResponseText = $item.text();

        $item.text("");
        this._ajax.enableTextLoading($item);

        var params = {
            contactId: contactId,
            action: action
        };

        me._ajax.post({
            url: Routing.generate(me._getSaveContactRequestResponseRoute()),
            data: params,
            onSuccess: function(data) {
                var $notification = $item.closest("[data-notificationModel]");
                if(!data.canceled) {
                    if(action == "accept")
                        var newText = "successfully added to contacts.";
                    else if(action == "decline")
                        var newText = "contact request was declined.";
                }
                else {
                    var newText = "canceled contact request.";
                }

                $notification.find("[data-notificationSubtext]").find("[data-button]")
                             .css("display", "none");
                $notification.find("[data-notificationText]")
                             .find(".text").text(newText);
            },
            onComplete: function() {
                $item.text(me._originalContactResponseText);

                me._isSavingContactRequestResponse = false;
                me._ajax.disableTextLoading($item);
            }
        });
    },

    _saveDeclineJoinTeamResponse: function($item, teamMemberId) {
        var me = this;

        if(this._isSavingJoinTeamResponse)
            return;

        this._isSavingJoinTeamResponse = true;

        var params = {
            teamMemberId: teamMemberId
        };

        me._ajax.post({
            url: Routing.generate('business_dashboard_decline_join_team_request'),
            data: params,
            onSuccess: function(data) {
                var $notification = $item.closest("[data-notificationModel]");
                var newText = "join team request was declined.";

                $notification.find("[data-notificationSubtext]").find("[data-button]")
                             .css("display", "none");
                $notification.find("[data-notificationText]")
                             .find(".text").text(newText);

                NtechApp.confirmForm.unload();
            },
            onComplete: function() {
                me._isSavingJoinTeamResponse = false;
            },
            onError: function(data) {
                var errText = "";
                for(var errName in data) 
                    errText += data[errName];

                NtechApp.confirmForm.unload();
                NtechApp.info.on(errText, 2500);
            }
        });
    },

    _updateAcceptJoinRequestNotification: function($item, memberName, positionName, memberId) {
        var $notification = $item.closest("[data-notificationModel]");
        var newText = "successfully added to team as " + positionName + ".";

        $notification.find("[data-notificationSubtext]").find("[data-button]")
                     .css("display", "none");
        $notification.find("[data-notificationText]")
                     .find(".text").text(newText);
    }
});